import React from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Badge,
} from 'reactstrap';
import IntlMessage from '../../../helpers/intlMessage';

const MultiplosExamesPage = (props) => {
  return (
    <Col
      className='multiplosExames-container espacamento-container-lateral'
      style={{
        height: props.alturaEditor(),
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      {props.multiplosExames === undefined && <p>Nenhum exame registrado</p>}
      {props.multiplosExames !== undefined &&
        props.multiplosExames.map((exame) => {
          return (
            <Row key={exame.id}>
              <Col>
                <Card style={{ margin: '4px -8px 0px 12px' }}>
                  <CardBody>
                    <CardTitle>{exame.exameNome}</CardTitle>
                    <CardText><IntlMessage id = "dashboards.examDetails.quantity"/> {exame.quantidade}</CardText>
                    {exame.faturado && (
                      <CardText
                        style={{
                          position: 'absolute',
                          right: '12px',
                          top: 'calc(50% - 10px)',
                        }}
                      >
                        <Badge color='success'><IntlMessage id = "dashboards.examDetail.billed"/></Badge>
                      </CardText>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
    </Col>
  );
};

export default MultiplosExamesPage;



// WEBPACK FOOTER //
// ./src/app/common/multiplosExames/multiplosExames.page.js